import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const AdminOrCompanyAdminRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    checkAuthorization();
  }, []);

  const checkAuthorization = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        setIsAuthorized(false);
        setLoading(false);
        return;
      }

      const { data: account, error } = await supabase
        .from('accounts')
        .select('is_admin, is_company_admin')
        .eq('id', user.id)
        .single();

      if (error) throw error;

      // Allow access if user is either a system admin OR a company admin
      setIsAuthorized(account?.is_admin === true || account?.is_company_admin === true);
      setLoading(false);
    } catch (error) {
      console.error('Error checking authorization:', error);
      setIsAuthorized(false);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand mx-auto"></div>
          <p className="mt-4 text-gray-600">Checking permissions...</p>
        </div>
      </div>
    );
  }

  if (!isAuthorized) {
    return <Redirect to="/user/dashboard" />;
  }

  return children;
};

export default AdminOrCompanyAdminRoute;
